import { render, staticRenderFns } from "./DashboardEncerrados.vue?vue&type=template&id=f9805826&scoped=true&"
import script from "./DashboardEncerrados.vue?vue&type=script&lang=js&"
export * from "./DashboardEncerrados.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEncerrados.vue?vue&type=style&index=0&id=f9805826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9805826",
  null
  
)

export default component.exports